import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { User } from "../_models/user";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthenticationService } from "./authentication.service";
import { CampaignFixer, Campaign, CustomerMap, ItemMap, InvoiceLineError, InvoiceErrors, FourDates } from "../_models/crmStats";
import { Setting } from "../_models/setting";


@Injectable()
export class SettingsService {

  campaignFixer: CampaignFixer = new CampaignFixer();
  pageSettings = { currentPage: 0, running: false };
  settings: Setting[] = [];
  invoiceSettings = {
    startDate: new Date(),
    endDate: new Date(),
    invoiceDate: new Date(),
    dueDate: new Date(),
    invPrefix: "Inv-", lastXero: 0, startDateE: new Date(),
    endDateE: new Date(),
    invoiceDateE: new Date(),
    dueDateE: new Date(),
    invPrefixE: "Inv-", lastXeroE: 0, breakPoint: 16, dueDays: 2, dueDaysE: 2, TaxType: '', TaxTypeE: '', EnquiryVAT: true, EnquiryInvalid: true,
    errorCustomersI: [], errorLinesI: [], errorCustomersE: [], errorLinesE: [], errorCountI: 0, errorCountE: 0,itemCodeErrorsI:[],itemCodeErrorsE:[]
  }
  reportSettings = {
    transferValue:true,crossCampaign:1
  }

  constructor(private http: HttpClient, private auth:AuthenticationService) {
    this.getSettings().subscribe((res) => {
      this.settings = res;
      this.setInvoiceSettings();
      this.publicInvoiceErrors.subscribe(() => {
        
      });
    });
  }

  checkInvoiceErrors = new Observable(observer => {
    this.checkCRMBatch().subscribe(() => {
      this.publicInvoiceErrors.subscribe(() => {
        observer.next(true);
        observer.complete();
      });
    })
  });

  publicInvoiceErrors = new Observable(observer => {
    this.getInvoiceErrors().subscribe((data: InvoiceErrors) => {
      this.invoiceSettings.errorCustomersI = data.ICustomerMaps;
      this.invoiceSettings.errorLinesI = data.IInvoiceLineErrors;
      this.invoiceSettings.errorCustomersE = data.ECustomerMaps;
      this.invoiceSettings.errorLinesE = data.EInvoiceLineErrors;
      this.invoiceSettings.itemCodeErrorsI = data.IItemCodeErrors;
      this.invoiceSettings.itemCodeErrorsE = data.EItemCodeErrors;
      this.invoiceSettings.errorCountI = data.ICustomerMaps.length + data.IInvoiceLineErrors.length + data.IItemCodeErrors.length;
      this.invoiceSettings.errorCountE = data.ECustomerMaps.length + data.EInvoiceLineErrors.length + data.EItemCodeErrors.length;

      observer.next(true);
      observer.complete();
    });



  });
  checkCRMBatch() {
    let batch = this.invoiceSettings.errorLinesE.concat(this.invoiceSettings.errorLinesI);
    return this.http.post(this.auth.baseUrl + 'api/CRMBatchCheck', batch, this.auth.getHeader())
      .map(() => {
        return
      });
  }
  getFourDates() {
    let fourDates = new FourDates();
    fourDates.StartI = this.invoiceSettings.startDate;
    fourDates.StartE = this.invoiceSettings.startDateE;
    fourDates.EndI = this.invoiceSettings.endDate;
    fourDates.EndE = this.invoiceSettings.endDateE;
    return fourDates;
  }
  getSettings() {
    return this.http.get(this.auth.baseUrl + 'api/Settings', this.auth.getHeader())
      .map((res: Setting[]) => { return res;});
  }
  updateInv() {
    let sdue = this.settings.filter(a => a.SettingId == 5)[0];
    let spre = this.settings.filter(a => a.SettingId == 4)[0];
    let stax = this.settings.filter(a => a.SettingId == 6)[0];
    let svat = this.settings.filter(a => a.SettingId == 7)[0];
    let sinval = this.settings.filter(a => a.SettingId == 9)[0];

    let sduee = this.settings.filter(a => a.SettingId == 11)[0];
    let spree = this.settings.filter(a => a.SettingId == 10)[0];
    let staxe = this.settings.filter(a => a.SettingId == 12)[0];

    sdue.SettingValue = this.invoiceSettings.dueDays.toString();
    spre.SettingValue = this.invoiceSettings.invPrefix;
    stax.SettingValue = this.invoiceSettings.TaxType;

    sduee.SettingValue = this.invoiceSettings.dueDaysE.toString();
    spree.SettingValue = this.invoiceSettings.invPrefixE;
    stax.SettingValue = this.invoiceSettings.TaxTypeE;

    svat.SettingValue = this.invoiceSettings.EnquiryVAT ? '1' : '0';
    sinval.SettingValue = this.invoiceSettings.EnquiryInvalid ? '1' : '0';
    let doupdate: Setting[] = [];
    doupdate.push(sdue);
    doupdate.push(spre);
    doupdate.push(stax);
    doupdate.push(sduee);
    doupdate.push(spree);
    doupdate.push(staxe);
    doupdate.push(svat);
    doupdate.push(sinval);

    return this.http.put(this.auth.baseUrl + 'api/Settings', doupdate, this.auth.getHeader())
      .map((res) => { return res; });
  }
  updateSetting(doupdate: Setting[]) {
    return this.http.put(this.auth.baseUrl + 'api/Settings', doupdate, this.auth.getHeader())
      .map((res) => { return res; });
  }
  updateRepSetting(which:number,val:string) {
    let set = this.settings.filter(a => a.SettingId == which)[0];
    set.SettingValue = val;
    return this.updateSetting([set]).subscribe(() => { });
  }
  setInvoiceSettings() {
    var today = new Date();
    var check = this.settings.filter(a => a.SettingId == 0);

    this.settings.forEach((setting) => {
      switch (setting.SettingId) {
        case 0:
          this.invoiceSettings.breakPoint = parseInt(setting.SettingValue);
          break;
        case 4:
          this.invoiceSettings.invPrefix = setting.SettingValue;
          break;
        case 5:
          this.invoiceSettings.dueDays = parseInt(setting.SettingValue);
          break;
        case 6:
          this.invoiceSettings.TaxType = setting.SettingValue;
          break;
        case 7:
          this.invoiceSettings.EnquiryVAT = setting.SettingValue=="1";
          break;
        case 8:
          this.reportSettings.transferValue = setting.SettingValue == "1";
          break;
        case 9:
          this.invoiceSettings.EnquiryInvalid = setting.SettingValue == "1";
          break;
        case 10:
          this.invoiceSettings.invPrefixE = setting.SettingValue;
          break;
        case 11:
          this.invoiceSettings.dueDaysE = parseInt(setting.SettingValue);
          break;
        case 12:
          this.invoiceSettings.TaxTypeE = setting.SettingValue;
          break;
        case 13:
          this.reportSettings.crossCampaign = parseInt(setting.SettingValue);
          break;
      }
    })

    //this.invoiceSettings.breakPoint = parseInt(this.settings.filter(a => a.SettingId == 0)[0].SettingValue);
    //this.invoiceSettings.dueDays = parseInt(this.settings.filter(a => a.SettingId == 5)[0].SettingValue);
    //this.invoiceSettings.TaxType = this.settings.filter(a => a.SettingId == 6)[0].SettingValue;


    //this.invoiceSettings.EnquiryVAT = this.settings.filter(a => a.SettingId == 7)[0].SettingValue == '1';
    //this.invoiceSettings.EnquiryInvalid = this.settings.filter(a => a.SettingId == 9)[0].SettingValue == '1';

    if (today.getDate() < this.invoiceSettings.breakPoint) {
      this.invoiceSettings.startDate = this.subMonth(today);
      this.invoiceSettings.startDate.setDate(this.invoiceSettings.breakPoint);
      this.invoiceSettings.endDate = new Date(this.invoiceSettings.startDate.getFullYear(), this.invoiceSettings.startDate.getMonth() + 1, 0);
    }
    else {
      this.invoiceSettings.startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      this.invoiceSettings.endDate = new Date(today.getFullYear(), today.getMonth(), this.invoiceSettings.breakPoint - 1);
    }
    this.invoiceSettings.startDateE = this.subMonth(today);
    this.invoiceSettings.startDateE.setDate(1);
    this.invoiceSettings.endDateE = new Date(this.invoiceSettings.startDateE.getFullYear(), this.invoiceSettings.startDateE.getMonth()+1, 0);

    this.invoiceSettings.invoiceDate = new Date(today);
    this.invoiceSettings.invoiceDateE = new Date(today);

    this.invoiceSettings.dueDate = new Date(this.invoiceSettings.invoiceDate);
    this.invoiceSettings.dueDate.setDate(this.invoiceSettings.invoiceDate.getDate() + this.invoiceSettings.dueDays);

    this.invoiceSettings.dueDateE = new Date(this.invoiceSettings.invoiceDateE);
    this.invoiceSettings.dueDateE.setDate(this.invoiceSettings.invoiceDateE.getDate() + this.invoiceSettings.dueDaysE);

  }
  subMonth(date: Date) {
    let curr = date.getMonth();
    let currY = date.getFullYear();
    let last = curr - 1;
    if (last < 0) {
      currY = currY - 1;
      last = 11;
    }
    let prev = new Date(currY, last, date.getDate());
    return prev;

  }
  getCampaigns() {
    return this.http.get(this.auth.baseUrl + 'api/CampaignHelpers', this.auth.getHeader())
      .map((res: CampaignFixer) => { return res });
  }
  getCustomerMap() {
    return this.http.get(this.auth.baseUrl + 'api/CustomerMaps', this.auth.getHeader())
      .map((res: CustomerMap[]) => { return res });
  }

  getItems() {
    return this.http.get(this.auth.baseUrl + 'api/ItemCodes', this.auth.getHeader())
      .map((res: ItemMap[]) => { return res });
  }
  getInvoiceErrors() {
    let fourDates = this.getFourDates();
    return this.http.post(this.auth.baseUrl + 'api/InvoiceErrors', fourDates, this.auth.getHeader())
      .map((res:InvoiceErrors) => { return res; });
  }
  checkCRMEntry(ref:string) {
    return this.http.get(this.auth.baseUrl + 'api/CRMEntryCheck?reference='+ref, this.auth.getHeader())
      .map(() => { return });
  }
  updateCampaign(cam:Campaign) {
    if (cam.Id > 0) {
      //update api/Campaigns/5
      return this.http.put(this.auth.baseUrl + 'api/Campaigns/'+cam.Id,cam, this.auth.getHeader())
        .map((res: CampaignFixer) => { return res });
    }
    else {
      //insert
      return this.http.post(this.auth.baseUrl + 'api/Campaigns',cam, this.auth.getHeader())
        .map((res: CampaignFixer) => { return res });
    }
  }
  updateCustomer(cus: CustomerMap) {
    return this.http.put(this.auth.baseUrl + 'api/CustomerMaps/' + cus.Id, cus, this.auth.getHeader())
      .map((res: CampaignFixer) => { return res });
  }
  updateItem(item: ItemMap) {
    return this.http.put(this.auth.baseUrl + 'api/ItemCodes/' + item.Id, item, this.auth.getHeader())
      .map((res: CampaignFixer) => { return res });
  }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/_services/settings.service.ts